import type { IFetchRequest, ResponseTypes } from '../../interface/util';
import type { MediaBinaryStorageTypeMap } from '../interface/media';

const RESPONSETYPE_MAP: Record<keyof MediaBinaryStorageTypeMap, ResponseTypes> = {
    Blob: 'blob',
    ArrayBuffer: 'arraybuffer',
    none: 'blob',
};

export const requestForURL = (
    url: string,
    type: keyof MediaBinaryStorageTypeMap,
): IFetchRequest => ({
    url,
    method: 'GET',
    /* map our interface response type to Fetchers type */
    expectedResponseType: RESPONSETYPE_MAP[type],
});

const module = {
    requestForURL,
};

export default module;
